<template>
  <v-container fluid grid-list-lg mb-3>

  <div class="text-center">
      <v-dialog
      v-model="dialog"
      width="500px"
    >
      <v-card>
        <v-container fluid grid-list-lg mb-3>
        <v-card-text>
          <v-alert :value="true" v-if="passwordError != null" type="error">{{ passwordError.message }}</v-alert>
         Please re-enter your password in order to confirm your changes.
         </v-card-text>
          <v-form ref="form" v-model="passValid" @submit="verifyPassword">
              <v-layout row>
                <v-flex xs12>
                  <v-text-field
                    outline
                    v-model="pass"
                    :rules="passRules"
                    label="password"
                    type="password"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-card-actions>
                <v-btn color="primary" block type="submit" :disabled="!passValid || !ready">Authenticate &amp; Save</v-btn>
                <v-btn color="primary" block @click="dialog = false">Close</v-btn>
              </v-card-actions>
          </v-form>
        
        </v-container>
      </v-card>
    </v-dialog>
  </div>

    <v-layout row wrap>
      <v-flex xs12 sm6 offset-sm3>
        <h2 class="heading-2 align-left">Personal Information</h2>

        <v-alert :value="true" v-if="error != null" type="error">{{ error.message }}</v-alert>
        <v-alert :value="true" v-if="ticketMessage != null" type="error">{{ ticketMessage}}</v-alert>
        <v-alert :value="true" v-if="success != null" type="success">{{ success.message }}</v-alert>

        <v-layout justify-center column>
          
          <template v-if="ready">
          
            <v-form ref="form" v-model="valid" @submit="requestVerification">
              <v-layout row>
                <v-flex xs12>
                  <v-text-field
                    outline
                    v-model="firstName"
                    :rules="firstNameRules"
                    label="First Name *"
                    required
                  ></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <v-text-field
                    outline
                    v-model="lastName"
                    :rules="lastNameRules"
                    label="Last Name *"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex xs12>
                  <v-text-field
                    outline
                    v-model="username"
                    :rules="usernameRules"
                    readonly
                    label="Email *"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex xs3 pb-0>


                <v-select :hide-details="true" label="Phone Country*" :items="countries" item-value="code" v-model="phoneCountry" outline required>
<template slot="selection" slot-scope="data">
    <!-- HTML that describe how select should render selected items -->
    {{ data.item.emoji }} (+{{ data.item.phoneCode }})
  </template>
  <template slot="item" slot-scope="data">
    <!-- HTML that describe how select should render items when the select is open -->
    {{ data.item.emoji }} {{ data.item.name }} (+{{ data.item.phoneCode }})
  </template>

</v-select>

                <!--
                  <v-select :hide-details="true" :items="countries" v-model="phoneCountry" item-text="{emoji} {code}" item-value="code" label="Country*"></v-select>
                -->
                
                </v-flex>
                <v-flex xs9>
                  <v-text-field
                    outline
                    v-model="phoneNumber"
                    :rules="phoneRules"
                    label="Mobile Phone Number*"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex xs12 sm3>Date of Birth*</v-flex>
                <v-flex xs12 sm3>
                  <v-select
                    :items="days"
                    label="DD*"
                    v-model="dobDay"
                    :rules="dobRules"
                    required
                    outline
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-select
                    :items="months"
                    label="MM*"
                    v-model="dobMonth"
                    :rules="dobRules"
                    outline
                    required
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-select
                    :items="years"
                    label="YYYY*"
                    v-model="dobYear"
                    :rules="dobRules"
                    outline
                    required
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout row>
                <h3 class="heading-3 align-left address-align">Address</h3>
              </v-layout>
              <v-layout row>
                <p
                  class="address-align"
                >In order to provide online ticketing purchasing functionality we require your primary billing address.</p>
              </v-layout>
              <v-layout row>
                <v-flex xs12 pb-0>
                  <v-text-field
                    outline
                    v-model="address1"
                    :rules="addressRules"
                    label="Address line 1*"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12 pb-0>
                  <v-text-field outline v-model="address2" label="Address line 2" required></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12 pb-0>
                  <v-text-field outline v-model="address3" label="Address line 3" required></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12 pb-0>
                  <v-text-field outline v-model="locality" :rules="addressRules" label="City / Town*" required></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12 pb-0>
                  <v-text-field outline v-model="region" label="County / Region" required></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12 pb-0>
                  <v-text-field
                    outline
                    v-model="postal_code"
                    :rules="addressRules"
                    label="Postal Code*"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12 pb-0>
                  <v-select :items="countries" v-model="country" item-text="name" label="Country*" outline></v-select>
                </v-flex>
              </v-layout>
              <v-layout row align-center mx-1>
                <v-spacer />
                <button
                  type="submit"
                  class="button"
                  :disabled="!valid || !ready"
                  color="success"
                >Save Details</button>
              </v-layout>
            </v-form>
          </template>

          <template v-else>
            <div class="text-xs-center">
              <v-progress-circular :size="50" color="accent" indeterminate></v-progress-circular>
            </div>
          </template>
        </v-layout>
      </v-flex>
    </v-layout>
    
  </v-container>
  
</template>

<script>
import axios from "axios";
import { parsePhoneNumber } from 'awesome-phonenumber'
export default {
  name: "UserProfile",
  data() {
    return {
      ready: false,
      valid: true,
      passValid: true,
      pass:"",
      passRules: [
        v => !!v || 'Password is required',
        v => (v && v.length >= 8) || 'Remember, your password will have been at least 8 characters, contained a special character and contained both an upper case and a lower case letter'
      ],
      firstNameRules: [v => !!v || "First name is required"],
      lastNameRules: [v => !!v || "Last name is required"],
      usernameRules: [
        v => !!v || "Email address is required",
        v => /.+@.+/.test(v) || "Email must be valid"
      ],
      dobRules: [v => !!v || "Date of Birth is required"],
      addressRules: [v => !!v || "You must fill in this address field"],
      firstName: "",
      lastName: "",
      phoneNumber: "",
      phoneCountry: "",
      phoneNormalised:"",
      username: "",
      dobDay: null,
      dobMonth: null,
      dobYear: null,
      originalEmail: "",
      error: null,
      passwordError: null,
      ticketMessage: null,
      success: null,
      loading: false,
      address: null,
      address1: "",
      address2: "",
      address3: "",
      locality: "",
      region: "",
      postal_code: "",
      country: "",
      countries: [],
      days: [],
      months: [],
      years: [],
      dialog: false,
      passwordVerified: false,
    };
  },
  created() {
    // load this user's latest information
    this.$getCurrentUserAttributes().subscribe(
      userData => {
        // console.log(userData)
        console.log("getting user attributes");
        this.username = userData.email;
        this.firstName = userData.given_name;
        this.lastName = userData.family_name;
        
        this.originalEmail = userData.email;

        const pn = parsePhoneNumber(userData.phone_number);
        console.log('PHONE Number pasring', pn)
        if(pn.valid){
          this.phoneNumber = pn.number.national
          this.phoneCountry = pn.regionCode
          console.log('PHONE Number set', this.phoneNumber, this.phoneCountry)
        }

        if (userData.birthdate) {
          var birthdayDates = userData.birthdate.split("-");
          this.dobDay = parseInt(birthdayDates[2]);
          this.dobMonth = parseInt(birthdayDates[1]);
          this.dobYear = parseInt(birthdayDates[0]);
        }

        if (userData["address"]) {
          this.address = JSON.parse(userData["address"]);
          if (this.address) {
            console.log(
              "Address",
              typeof this.address["street_address"],
              this.address["street_address"]
            );
            //set our address fields
            if (this.address["street_address"]) {
              var addressFields = this.address["street_address"].split("\n");
              this.address1 = addressFields[0];
              this.address2 = addressFields[1];
              this.address3 = addressFields[2];
            }
            this.locality = this.address.locality;
            this.region = this.address.region;
            this.postal_code = this.address.postal_code;
            this.country = this.address.country;
          }
        }
        fetch("/countries.json")
          .then(r => r.json())
          .then(
            json => {
              this.countries = json.countries;
            },
            response => {
              console.log("Error loading json:", response);
            }
          );

        // tell the app that we've finished loading
        this.ready = true;
      },
      err => {
        console.log("Unable to load user profile, session may not be present.");
      }
    );
  },
  watch: {
    phoneCountry:  {
      immediate: true,
      async handler() {
        await this.$nextTick();
        this.$refs.form.validate();
      }
    }
  },
  
  computed: {
    phoneRules() {
      //alert(this.phoneNumber)
      const pn = parsePhoneNumber( this.phoneNumber , { regionCode: this.phoneCountry});
      //console.log(pn)
      console.log('Phone number is', pn.valid)
      if (!this.phoneNumber) {
        console.log('Phone number Doesn\'t exist')
        return ["Phone number is required"];
        
      } else {
        console.log('Phone number exists')
        return [() => pn.valid|| "Please ensure you have selected your phone country and entered the number correctly"];
      }
    }
  },
  mounted() {
    this.populateDates();
    if(typeof localStorage.returnUrl != 'undefined'){
      if(localStorage.returnUrl.includes('ticket')){
        this.ticketMessage = 'You must enter your address before being able to complete a ticket purchase'
      }
    }
  },
  methods: {
    capFirstCar(string){
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    pad(num, size) {
      var s = num + "";
      while (s.length < size) s = "0" + s;
      return s;
    },
    populateDates() {
      console.log("ADDING DATES");
      for (var d = 1; d < 32; d++) {
        this.days.push(d);
      }
      for (var m = 1; m < 13; m++) {
        this.months.push(m);
      }
      var thisYear = new Date().getFullYear();
      for (var y = thisYear + 1; y > 1900; y--) {
        this.years.push(y);
      }
    },
    redirectUser(e) {
      if (localStorage.returnUrl) {
        // if they were from a trusted referrer and we need to send them back with a JWT
        alert('You are being redirected to the ticketing website')
        var authUser = this.$getAuthenticatedUser();
        authUser.getSession(function(err, session) {
          // console.log ('jwtToken', session.getIdToken().getJwtToken())
          var jwtToken = session.getIdToken().getJwtToken();
          var firstQueryChar = "?";
          if (localStorage.returnUrl.includes("?")) {
            // account for ? in string
            firstQueryChar = "&";
          }
          var redirect = localStorage.returnUrl;
          if (!localStorage.suppressToken) {
            redirect = redirect + firstQueryChar + "token=" + jwtToken;
          }
          console.log("redirecting to " + redirect);
          localStorage.removeItem("returnUrl");
          localStorage.removeItem("suppressToken");
          window.location = redirect;
        });
      }
    },
    verifyPassword (e){
      e.preventDefault();
      
      if(this.passwordVerified === false){
        var email = this.username;
        var password = this.pass;
        var vm = this
        console.log('Password verification being processed')
        this.$passwordCheck(email, password).subscribe((data) => {
          console.log('user authenticated')
          vm.passwordVerified = true
          vm.dialog = false
          vm.updateUser(e)
        }, 
        (err)=> {
          this.dialog = true;
          this.success = null;
          this.passwordError = err;
          this.ready = true;
        });
      } else {
        console.log('Password already verified')
        this.updateUser()   
      }
    },
    requestVerification(e) {
      e.preventDefault();
      this.dialog = true
    },
    updateUser(e) {

      e.preventDefault();
      this.ready = false;
      
      var email = this.username;
      //captalise frst letters
      var firstName = this.firstName = this.capFirstCar(this.firstName)
      var lastName = this.lastName = this.capFirstCar(this.lastName);

      var attributesList = {
        given_name: firstName,
        family_name: lastName
      };

      const pn = parsePhoneNumber( this.phoneNumber , { regionCode: this.phoneCountry});
      if(pn.valid === true){
        attributesList['phone_number'] = pn.number.e164
        console.log('Saving phone', attributesList['phone_number'])
      }

      if (this.dobDay && this.dobMonth && this.dobYear) {
        attributesList["birthdate"] =
          this.dobYear +
          "-" +
          this.pad(this.dobMonth, 2) +
          "-" +
          this.pad(this.dobDay, 2);
      }

      var street_address =
        this.address1 + "\n" + this.address2 + "\n" + this.address3;

      var address = {
        street_address: street_address,
        locality: this.locality,
        region: this.region,
        postal_code: this.postal_code,
        country: this.country
      };
      attributesList["address"] = JSON.stringify(address);

      if (this.originalEmail.toLowerCase() != email.toLowerCase()) {
        attributesList["email"] = email;
        // trigger verification workflow
      }

      this.$updateAttributes(attributesList).subscribe(
        response => {
          console.log("update successful");
          this.error = null;
          this.success = response;
          this.ready = true;
          window.scrollTo(0,0)
          this.$getSession().subscribe(
            sessionData => {
              console.log("Session data", sessionData);
              // Post Data to SeatGeek's server (using the id Token)
              var vm = this;
              setTimeout(function() {
                var lastSub = vm.$cookie.get(
                  `CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.LastAuthUser`
                );
                var idToken = vm.$cookie.get(
                  `CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.${lastSub}.idToken`
                );
                axios
                  .post(`${process.env.VUE_APP_SEATGEEK_SRO_ENDPOINT}`, idToken)
                  .then(function(seatGeekResponse) {
                    // Tell our parent window that the profile has been updated (if one exists)
                    if (window.opener) {
                      console.log("sending profileUpdated postMessage");
                      window.opener.postMessage("profileUpdated", "*");
                    }
                    vm.redirectUser();
                  })
                  .catch(function(error) {
                    // Tell our parent window that the profile has been updated (if one exists)
                    if (window.opener) {
                      console.log("sending profileUpdated postMessage");
                      window.opener.postMessage("profileUpdated", "*");
                    }
                    vm.redirectUser();
                  });
              }, 500);
            },
            err => {
              console.log("Unable to load user session data");
            }
          );
        },
        err => {
          //if we get an UnkownError it is more than likely because the user has a status of 'FORCE_CHANGE_PASSWORD' in AWS Cognito
          // console.log(err.message)
          this.success = null;
          this.error = err;
          this.ready = true;
        }
      );
    }
  }
};
</script>

<style scoped>
.address-align {
  margin-left: 20px;
}
.v-select {
  padding-top: 0px!important;
min-height: 50px!important;
}
.v-input__control {
 min-height: 50px!important;
}
</style>